/* eslint-disable */
import theme from '../../theme'
import PassengerBox from './PassengerBox'
import AirportSelector from './AirportSelector'
import axios from 'axios'
import SearchBoxService from "../../services/searchBox.service";
//import SearchBoxMessages from "./SearchBox.Messages";
import Helper from "../helper";
import Validation from "./SearchBox.Validation";
import AirlineSelector from "../CustomControls/AirlineSelector";
import VueClipboard from 'vue-clipboard2';
import UiCaptions from '../../Languages/FlightSearch/SearchBox.lang';
// import MulticityBox from './MulticityBox'

function getSearchPara(searchPara){
  var fnc = ap => {
      try {
          var code = ap.split('-')[0];
          code = code.trim();
          var place = ap.split('-')[1];
          place = place.trim();
          return [code,place];            
      } catch (error) {
          return ["",""]
      }
  }

  var origin = fnc(searchPara.origin);
  var destination = fnc(searchPara.destination);    
  var para = {
      WholesaleId:searchPara.wholesaleId,
      UrlId:searchPara.urlId,
      Trip:searchPara.trip? "R":"O",
      Airline:searchPara.airline==""?"--":searchPara.airline,
      Origin: origin[0],
      Destination:destination[0],
      DepartureDate:searchPara.departureDate==null?
        '': searchPara.departureDate.replace(/-/g,''),
      ReturnDate:searchPara.returnDate==null? 
        '': searchPara.returnDate.replace(/-/g,''),
      Class:searchPara.seatClass,
      AdtPassengerCount:searchPara.adtPassengerCount,
      CnnPassengerCount:searchPara.cnnPassengerCount,
      InfPassengerCount:searchPara.infPassengerCount,
      StuPassengerCount:searchPara.stuPassengerCount,
      MarkupLevel:searchPara.markupLevel,
      StyleName:searchPara.styleName,
      Language:searchPara.language,
      AirportOfOrigin:origin[1],
      AirportOfDestination:destination[1],
      FlightType:searchPara.flightType
  };

  return para;
}

const SearchBoxCode = {
  directives:[VueClipboard],
  created(){
      this.loadCityAirports();
      this.getAirlinesForSelection();
      if (this.P_SearchCriteriaBase64!=null && this.P_SearchCriteriaBase64!=""){
          // this.readSearchFilteringValuesFromPara();
          if(this.$store.state.triptype!=null && this.$store.state.triptype!="M"){
              // this.readStoredSearchFilteringValues();
          }else{
              this.$store.commit("updateSearchCriteriaBase64",null);
              this.$router.push({
                name:'SharedLink',params:{sid:this.P_SearchCriteriaBase64}
              });
          }
          
      }
      //else{
      //     this.readStoredSearchFilteringValues();    
      // }
      this.readStoredSearchFilteringValues();
      this.getBackToHomeUrl();
      // this.assigntrip();
      this.searchPara.trip=this.P_TripType;
  },
  props:[
    'SelectedLanguage',
    'P_WholesaleId',
    'P_UrlId',
    'P_SearchCriteriaBase64',
    'P_TripType'],
  components:{
      PassengerBox, AirportSelector, AirlineSelector
  },
  data(){
      return {
          uiCaptions:UiCaptions,
          helper:Helper,
          buttonGroupDefaults:[0,1],
          searchBoxControlsDisabilities:{
              originSelector:false,
              destinationSelector:false,
              airlineSelector:false,
              dateOfDeparturePicker:false,
              dateOfReturnPicker:false,
              passengerPicker:false,
              searchButton:false,
              copyLinkButton:false,
          },
          validation:{
              showAlert:false,
              message:"",
          },
          storedSearchBoxValues:{
              origin:"",
              destination:"",
              departureDate:null,
              returnDate:null,
              trip:false,
              seatClass:"",
              airline:"--",
              passengerCountByPax:{
                  adult:0,
                  child:0,
                  infant:0,
                  student:0,
              },
          },
          searchPara:{
              wholesaleId:35,
              urlId:382,
              trip:"",
              airline:"--",
              origin:"",
              destination:"",
              departureDate:"",
              returnDate:"",
              seatClass:"",
              adtPassengerCount:0,
              cnnPassengerCount:0,
              infPassengerCount:0,
              stuPassengerCount:0,
              markupLevel:0,
              styleName:"1G1",
              language:this.SelectedLanguage,
              flightType:"0",              
          },
          flightFares:null,
          indeterminate:false,
          showSearchBox:true,
          seatClasses:[
              {text:'Economy', value:'Y'},
              {text:'Business', value:'C'},
              {text:'First', value:'F'}
          ],
          defaultColors:{
              primary:theme.primary.base,
              secondary:theme.secondary
          },
          showFareIndices:[1,7,13,300],
          emitters:{
              SearchId:'SearchId'
          },
          searchId:null,
          cityAirports:[],              
          backToHomeUrl:"",
          snackbar:{
              show:false,
              text:"",
          },
          airlines:[],
          linkToCopy:"",
          showCopyLinkDialog:false,
          showMulticity:false,
          multicityselection:false,
          triptype:"",
          isbackurl:false
      }
  },
  methods:{
      onCopyToClipboard(){
          this.showCopyLinkDialog = false;       
          setTimeout(() => {
              this.snackbar.text = "Shared url coppied.";
              this.snackbar.show = true;  
          }, 1000);   
      },
      onCopyToClipboardErr(){
          this.showCopyLinkDialog = false;
          setTimeout(() => {
              this.snackbar.text = "Cannot coppy.";
              this.snackbar.show = true;  
          }, 1000);                       
      },
      copyLinkDialogClick(){
          this.showCopyLinkDialog = false;
      },
      getAirlinesForSelection(){
          SearchBoxService.getAirlines().then((rslt)=>{
              this.airlines = [];
              if (rslt.data!=null && rslt.data.length>0){
                  var items = rslt.data;
                  items.forEach((al)=>{
                      this.airlines.push(
                          al.Code +" - " + al.Name
                      )
                  })
              }
          });
      },
      getBackToHomeUrl(){
          SearchBoxService.getBackToHomeUrl().then((rslt=>{
              this.backToHomeUrl = rslt.data;
              if (this.backToHomeUrl.indexOf('http://')<0||
              this.backToHomeUrl.indexOf('https://')>0){
                  this.backToHomeUrl = "http://" + this.backToHomeUrl;
              }
          }));
      },
      departureDateChanged(){
          //alert(this.searchPara.trip);
          let date1 = this.searchPara.departureDate;
          let date2 = this.searchPara.returnDate;

          if (date1.length==10){
              let m1 = parseInt( date1.split("-")[0] + date1.split("-")[1]);
              if (this.P_TripType){
                  if (date2==null){
                      this.searchPara.returnDate = date1;
                  }else {
                      if (date2.length==10){
                          let m2 = parseInt(date2.split("-")[0] + 
                            date2.split("-")[1]);
                          if (m1>m2){
                              this.searchPara.returnDate = date1;
                          }
                      }
                  }
              }
          }
      },        
      copyLink() {
          SearchBoxService.getSharedSearchResultUrl().then((result)=>{
              //alert(result.data);
              this.linkToCopy = result.data;
              this.$copyText(result.data).then(()=>{
                  this.snackbar.text = "Shared url coppied.";
                  this.snackbar.show = true;
              },(e)=>{
                  this.showCopyLinkDialog = true;
                  this.snackbar.text = "Shared url coppied.";
                  this.snackbar.show = true;
              });
              //
          });            
      },        
      validateSearchPara(){

          this.validation.showAlert = false;
          this.validation.message = "";

          let vald = Validation.validateSearchPara(this.searchPara); 
          this.validation.showAlert = vald.showAlert;
          this.validation.message = vald.message;
          return vald.errorCode;
      },
      readSearchFilteringValuesFromPara(){

          SearchBoxService.decodeFlightSearchBoxValues(this.P_SearchCriteriaBase64)
            .then((rslt)=>{                
              let srchCri = rslt.data;
              if(srchCri.TripType!=null && srchCri.TripType!="M"){
              this.storedSearchBoxValues.trip = srchCri.Trip;
              this.storedSearchBoxValues.origin = srchCri.Origin;
              this.storedSearchBoxValues.destination = srchCri.Destination;
              this.storedSearchBoxValues.departureDate = srchCri.DepartureDate;
              this.storedSearchBoxValues.returnDate = srchCri.ReturnDate;
              this.storedSearchBoxValues.airline = srchCri.Airline;
              this.storedSearchBoxValues.seatClass = srchCri.SeatClass;
              this.storedSearchBoxValues
                .passengerCountByPax.adult = srchCri.AdultCount;
              this.storedSearchBoxValues
                .passengerCountByPax.child = srchCri.ChildCount;
              this.storedSearchBoxValues
                .passengerCountByPax.infant = srchCri.InfantCount;
              this.searchPara.adtPassengerCount = this.storedSearchBoxValues
                .passengerCountByPax.adult;
              this.searchPara.cnnPassengerCount = this.storedSearchBoxValues
                .passengerCountByPax.child;
              this.searchPara.infPassengerCount = this.storedSearchBoxValues
                .passengerCountByPax.infant;
              this.$emit('PassengerCountsByType',{
                adultCount:srchCri.AdultCount,
                childCount:srchCri.ChildCount,
                infantCount:srchCri.InfantCount
              })

              
              this.searchPara.origin = this.storedSearchBoxValues.origin;
              this.searchPara.destination = this.storedSearchBoxValues.destination;
              this.searchPara.trip = this.storedSearchBoxValues.trip;
              this.searchPara.airline = this.storedSearchBoxValues.airline;
              this.searchPara
                .departureDate = this.storedSearchBoxValues.departureDate;
              this.searchPara.returnDate = this.storedSearchBoxValues.returnDate;
              this.P_TripType = this.storedSearchBoxValues.trip;
              this.searchPara.seatClass = this.storedSearchBoxValues.seatClass;
              this.searchPara.urlId = this.$store.state.urlId;
              this.searchPara.markupLevel = this.$store.state.mlv;
              this.$store.commit('updateSearchBoxValues',this.searchPara);
              this.isbackurl=true;
              this.$store.commit("updateSearchCriteriaBase64",null);
              if (srchCri.Origin!=null&&
                  srchCri.Origin!=""){
                  setTimeout(()=>{
                      this.submitSearch(this.searchPara);
                  },2000); 
              }  
              }
          });

        
      },
      readStoredSearchFilteringValues(){
          if(this.$store.state.triptype!="M"){            
              this.storedSearchBoxValues
                .trip = this.$store.state.searchBoxValues.trip;
              this.storedSearchBoxValues
                .origin = this.$store.state.searchBoxValues.origin;
              this.storedSearchBoxValues
                .destination = this.$store.state.searchBoxValues.destination;
              this.storedSearchBoxValues
                .departureDate = this.$store.state.searchBoxValues.dateOfDeparture;
              this.storedSearchBoxValues
                .returnDate = this.$store.state.searchBoxValues.dateOfReturn;
              this.storedSearchBoxValues
                .airline = this.$store.state.searchBoxValues.airline;
              this.storedSearchBoxValues
                .seatClass = this.$store.state.searchBoxValues.seatClass;
              this.storedSearchBoxValues
                .passengerCountByPax.adult = this.$store
                .state.searchBoxValues.passengerCountByPax.adult;

              let adultAndStudent = this.storedSearchBoxValues.passengerCountByPax.adult;
              adultAndStudent += this.$store.state
                .searchBoxValues.passengerCountByPax.student;

              if (adultAndStudent == 0){
                this.storedSearchBoxValues.passengerCountByPax.adult = 1
              }
              this.storedSearchBoxValues
                .passengerCountByPax.child = this.$store.state
                .searchBoxValues.passengerCountByPax.child;
              this.storedSearchBoxValues
                .passengerCountByPax.infant = this.$store.state
                .searchBoxValues.passengerCountByPax.infant;
              this.storedSearchBoxValues
                .passengerCountByPax.student = this.$store.state
                .searchBoxValues.passengerCountByPax.student;

              this.searchPara.adtPassengerCount = this.$store
                .state.searchBoxValues.passengerCountByPax.adult;
              this.searchPara.cnnPassengerCount = this.$store
                .state.searchBoxValues.passengerCountByPax.child;
              this.searchPara.infPassengerCount = this.$store
                .state.searchBoxValues.passengerCountByPax.infant;
              this.searchPara.stuPassengerCount = this.$store
                .state.searchBoxValues.passengerCountByPax.student;
              this.$emit('PassengerCountsByType',{
                adultCount:this.$store.state
                  .searchBoxValues.passengerCountByPax.adult,
                childCount:this.$store.state
                  .searchBoxValues.passengerCountByPax.child,
                infantCount:this.$store.state
                  .searchBoxValues.passengerCountByPax.infan,
                studentCount: this.$store.state
                  .searchBoxValues.passengerCountByPax.student
              })

              this.searchPara.departureDate = this.storedSearchBoxValues.departureDate;
              this.searchPara.returnDate = this.storedSearchBoxValues.returnDate;
              this.searchPara.triptype = this.storedSearchBoxValues.trip;
              // this.P_TripType = this.storedSearchBoxValues.trip;
              this.searchPara.seatClass = this.storedSearchBoxValues.seatClass;
              this.searchPara.urlId = this.$store.state.urlId;
              this.searchPara.markupLevel = this.$store.state.mlv;
              if (this.searchPara.markupLevel == null) {
                this.searchPara.markupLevel = 1;
              }

              if (this.$store.state.searchBoxValues.origin!=null&&
              this.$store.state.searchBoxValues.origin!=""){
                  setTimeout(()=>{
                      this.submitSearch(this.searchPara);
                  },2000); 
              }
          }
      },
      stopLoadingUis(){
          this.indeterminate = false;
          this.$emit('LoadingAirlines',false);
      },
      getSeatClassByCode(code){
          var cls = this.seatClasses.filter(c=>c.value==code);
          return cls[0]==null?"":cls[0].text;
      },
      submitSearch(searchPara){
          
          try{  
              if(this.isbackurl==true){
                this.searchPara
                  .adtPassengerCount = this.storedSearchBoxValues
                  .passengerCountByPax.adult;
                this.searchPara
                  .cnnPassengerCount = this.storedSearchBoxValues
                  .passengerCountByPax.child;
                this.searchPara
                  .infPassengerCount = this.storedSearchBoxValues
                  .passengerCountByPax.infant;
                this.isbackurl=false;
              }
              
              this.$emit('FlightFares',[]);
              this.$emit('LoadingAirlines',true);
              this.$emit('AirlinesForFiltering',[]);
              this.$store.commit('updateSearchBoxValues',searchPara);
              this.$store.commit(
                'updateWholesaleIdAndUrlId',[this.P_WholesaleId,this.P_UrlId]);

              searchPara.language = this.SelectedLanguage;
              searchPara.trip=this.P_TripType;
              var para = getSearchPara(searchPara);
              this.indeterminate = true;
              this.flightFares= [];

              if (this.validateSearchPara()>0) {
                  this.indeterminate =false; 
                  return;
              }

              this.disableSearchBoxControls();
              
              axios.post ('/api/SearchBox/CreateFlightSearch',para)
                  .then (
                      result=>this.searchFlight(result.data)
                  )
                  .catch(() => {
                      this.stopLoadingUis();
                      this.enableSearchBoxControls();
                  });
                  // this.$emit('BtnSubmit',true);
                  this.$emit('FlightFares',[]);
                  this.$emit('LoadingAirlines',true);
                  this.$emit('AirlinesForFiltering',[]);
                  this.$store.commit('updateSearchBoxValues',searchPara);
                  this.$store.commit(
                    'updateWholesaleIdAndUrlId',[this.P_WholesaleId,this.P_UrlId]);                    
          }
          catch(err){
              this.enableSearchBoxControls();
          }
      },
      searchFlight(para){
          try{
              // let url = '/api/Go/SearchFlightForResponsive?';
              let url = '/api/Go/CacheSearchInfo?'
              axios.get(url+para).then(
                  result=>{
                      this.Flight2C_1(result.data);
                      this.searchId = para.replace("go=","");
                      this.$store.commit("updateSearchCriteriaBase64",this.searchId);
                      this.$emit(this.emitters.SearchId,this.searchId);
                  }
              ).catch(() => {
                      this.stopLoadingUis();
                      this.enableSearchBoxControls();
              });                 
          }
          catch(err){
              this.enableSearchBoxControls();
          }
      },
      Flight2C_1(para){
          try{
              axios.get('/api/Go/Flight2C_1ForResponsive?go='+para).then(
                  this.SubmitRouting()
              )
              .catch(() => {
                  this.stopLoadingUis();
                  this.enableSearchBoxControls();
              }); 
          }catch(err){this.enableSearchBoxControls();}
      },
      SubmitRouting(){
          try{
              axios.post('/api/Flight2C_1/SubmitRouting').then(
                  // eslint-disable-next-line no-unused-vars
                  result=>{
                  
                  this.ShowFareIndex()}
              )
              .catch(() => {
                  this.stopLoadingUis();
                  this.enableSearchBoxControls();
              }); 
          }catch(err){this.enableSearchBoxControls();}
      },
      ShowFareIndex(strtInd){
          if (strtInd==null) strtInd=0;
          try{
              axios.post(
                '/api/Flight2C_1/ShowFareIndexForResponsive',
                {startFareInd:this.showFareIndices[strtInd]}).then(
                  result=>{
                      
                      this.showSearchBox = false;
                      this.$emit('ShowSearchBox',this.showSearchBox);
                      if (typeof result.data=="string"){
                          //this.$emit('ResponseMessage',result.data);
                          if(strtInd==0) {
                              this.$emit('FlightFares',null);
                              this.$emit(
                                'ResponseMessage','Search result is not available.');
                          }else if (strtInd>0){
                              this.indeterminate = false;
                              this.$emit(this.emitters.SearchId,this.searchId);
                              this.getAirlines();
                          }
                          this.stopLoadingUis();
                      }else{
                              result.data.forEach((item)=>{
                                  this.flightFares.push(item);
                              })  
                          
                          if (strtInd<4) this.ShowFareIndex(strtInd+1);
                          this.$emit('FlightFares',this.flightFares);
                      }
                      this.enableSearchBoxControls();
                  }
              )
              .catch(() =>{
                  this.stopLoadingUis();
                  this.enableSearchBoxControls();
              });              
          }catch(err){
              this.enableSearchBoxControls();
          }
      },
      getPassengerCounts(c){
          this.searchPara.adtPassengerCount = c.adt;
          this.searchPara.cnnPassengerCount = c.cnn;
          this.searchPara.infPassengerCount = c.inf;
          this.searchPara.stuPassengerCount = c.stu;
          this.$emit('PassengerCountsByType',{
              adultCount:c.adt,
              childCount:c.cnn,
              infantCount:c.inf,
              studentCount:c.stu
          })
      },
      hideSearchBox(){
          this.showSearchBox=false;
          // this.$emit('ShowSearchBox',showSearchBox);
      },
      enableSearchBoxControls(){
          let disabled = false;
          this.searchBoxControlsDisabilities.originSelector =disabled;
          this.searchBoxControlsDisabilities.destinationSelector = disabled;
          this.searchBoxControlsDisabilities.airlineSelector = disabled;
          this.searchBoxControlsDisabilities.dateOfDeparturePicker = disabled;
          this.searchBoxControlsDisabilities.dateOfReturnPicker = disabled;
          this.searchBoxControlsDisabilities.passengerPicker = disabled;
          this.searchBoxControlsDisabilities.searchButton = disabled;
          this.searchBoxControlsDisabilities.copyLinkButton = disabled;
      },
      disableSearchBoxControls(){
          let disabled = true;
          this.searchBoxControlsDisabilities.originSelector =disabled;
          this.searchBoxControlsDisabilities.destinationSelector = disabled;
          this.searchBoxControlsDisabilities.airlineSelector = disabled;
          this.searchBoxControlsDisabilities.dateOfDeparturePicker = disabled;
          this.searchBoxControlsDisabilities.dateOfReturnPicker = disabled;
          this.searchBoxControlsDisabilities.passengerPicker = disabled;
          this.searchBoxControlsDisabilities.searchButton = disabled;
          this.searchBoxControlsDisabilities.copyLinkButton = disabled;
      },
      getAirlines(){
          
          var airlines = [];
          this.flightFares.forEach((item)=>{
              //if (airlineCodes.indexOf(item.Airline)<0) airlineCodes.push(item.Airline);
              airlines.push({
                  Code:item.Airline,
                  Name:null,
                  Price:item.AdultFare
              });
          });
          


          
          axios.post('/api/SearchBox/GetAirlineNames',airlines).then(result=>{
              var airlines = result.data.airlines;
              var minPrice = result.data.minPrice;
              var maxPrice = result.data.maxPrice;
              this.$emit('AirlinesForFiltering',airlines);
              this.$emit('LoadingAirlines',false);
              this.$emit('PriceMinMaxForFiltering',[minPrice,maxPrice]);
          }).catch(()=>{
          }
          );
      },
      loadCityAirports(){
          SearchBoxService.getCityAirports("").then(rslt=>{
              this.cityAirports = rslt.data;
          });
      },
      loadmulticity(){
          this.validation.showAlert = false;            
          if(this.showMulticity){
          this.showMulticity=false;
          this.searchPara.trip=false;
          }else{
              this.showMulticity=true;
              this.searchPara.trip=false;
          }
      },
      loadoneway(){
          this.validation.showAlert = false;
          this.showMulticity=false;
          this.multicityselection=false;
      },
      lnkedit(){
          this.showSearchBox=this.showSearchBox!=true;
          this.$emit('ShowSearchBox',this.showSearchBox);
      },              
  },
  computed:{
      isMobile(){
          let isMobile = Helper.display.isMobile(this.$vuetify.breakpoint.name);
          return isMobile;
      },
      selectedSeatClass(){
          let text = "";
          let conVals = ["","--"];
          if (conVals.indexOf(this.searchPara.airline.trim())>=0){
              text = this.getSeatClassByCode(this.searchPara.seatClass);
          }else {
              text = this.searchPara.airline +" (" +
                this.getSeatClassByCode(this.searchPara.seatClass) + ")";
          }
          return text;
      },
      // assigntrip(){
      //     return this.searchPara.trip=this.P_TripType;            
      //     // return this.triptype=this.P_TripType;
      // },
  },
};

export default SearchBoxCode;